import React from "react";
// import { useAuth0 } from "@auth0/auth0-react";
// import Button from '@mui/material/Button';
// import { Link } from 'react-router-dom'
import LoginButton from "./components/loginButton";

const LoginPage = () => {

  return (
    <div>
        <LoginButton />
    </div>
    
  );
}

export default LoginPage;